import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { OrAvatarComponent } from '@ui-components';
import { GamePlayerModel, MODAL_TOKEN, ModalProvider } from '@core';
import { cardReasonMapper } from '../../../application/utils';
import { PenaltyReason, PenaltyType } from '@core-http';

@Component({
  selector: 'lib-add-card-success-modal',
  templateUrl: './add-card-success-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, OrAvatarComponent]
})
export class AddCardSuccessModalComponent {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  @Input() player!: GamePlayerModel;
  @Input() reason!: PenaltyReason;

  get cardName(): string {
    return cardReasonMapper[this.reason].cardType === PenaltyType.RED ? 'czerwoną' : 'żółtą';
  }

  get cardIcon(): string {
    return cardReasonMapper[this.reason].icon;
  }

  closeModal(): void {
    this.modalProvider.dismissModal$();
  }
}
